module.exports = __webpack_public_path__ + "static/media/S.caf41b9a.jpg";